/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import "./index.scss";
import Button from "@/components/Button";
const AddLinkContent = ({
  saveNote,
}: {
  saveNote: (content: string) => void;
}) => {
  const [link, setLink] = useState("");

  const handleSubmit = (e: any) => {
    e.preventDefault();
  };

  const saveLink = () => {
    saveNote(link);
  };

  return (
    <div className="add-link-container">
      <form onSubmit={handleSubmit} className="form-container">
        <input
          type="url"
          placeholder="Enter your link here..."
          value={link}
          onChange={(e) => setLink(e.target.value)}
          className="link-input"
          required
        />
        <Button
          className="obro-secondary-btn full-w margin-top-10"
          onClick={() => saveLink()}
        >
          Kaydet
        </Button>
      </form>
    </div>
  );
};

export default AddLinkContent;
